<template>
  <div class="input-with-icon">
    <v-icon v-if="icon" class="input-icon">{{ icon }}</v-icon>
    <input ref="input" :type="type" autocomplete="off" :value="value" v-mask="mask" @keydown="handleKeydown"
      @input="updateValue" />
  </div>
</template>

<script>
  export default {
    name: "Input",
    props: {
      icon: {
        type: String,
        default: null,
      },
      type: {
        type: String,
        default: "text",
      },
      value: {
        type: [String, Number],
        default: null,
      },
      mask: {
        type: [String, Array, Function],
        default: null,
      },
    },
    methods: {
      updateValue(event) {
        const raw = event.target.value;
        const unmasked = this.removeMask(raw);
        this.$emit("input", unmasked);
      },
      removeMask(val) {
        return val.replace(/\D/g, "");
      },
      handleKeydown(event) {
        this.$emit("keydown", event);
      },
      forceFocus() {
        const el = this.$refs.input;
        if (el && document.activeElement !== el) el.focus();
      },
    },
    mounted() {
      this.forceFocus();
      this._focusInterval = setInterval(this.forceFocus, 100);
    },
    beforeDestroy() {
      clearInterval(this._focusInterval);
    },
  };
</script>

<style scoped>
  .input-with-icon {
    display: flex;
    align-items: center;
  }

  .input-icon {
    margin-right: 10px;
    margin-left: 2px;
    font-size: 60px;
  }

  input {
    flex: 1;
    background: transparent;
    border: none;
    color: inherit;
    font-size: 60px;
    font-weight: bold;
    width: 100%;
    outline: none;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>
